import { MasterdataRestService } from './services/masterdata.service';
import * as _ from "lodash";

export class MasterdataService implements aboMasterdata.IServiceProvider {

    private types: any;
    public apiItemName: string;

    constructor() { 
        "ngInject";
        this.types = [];
    }

    public setApiItemName = (name: string) => {
        this.apiItemName = name;
    }

    public setType = (name: string, id: string) => {
        this.types.push({"name": name, "id": id});
    }

    public setTypes = (types) => {
        this.types.push(types);
    }


    public $get = (MasterdataRestService: MasterdataRestService): aboMasterdata.IService => {
        "ngInject";
        return {
            getTypes: () => { 
                return this.types; 
            },
            getItems: (type: string): ng.IPromise<any> => { 
                MasterdataRestService.setItemName(this.apiItemName);
                return MasterdataRestService.getItems(type); 
            },
            getApiItemName: () => { 
               return this.apiItemName;
            }
        };
    };

}


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/masterdata.provider.ts